import React from "react";

const Introduction: React.FC = () => {
  return <h1>Introduction Page</h1>;
};

export default Introduction;
